export default "__VITE_ASSET__8197e2f1__"